var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82187 0.382812H14.1742C15.1762 0.384326 15.9961 1.07719 15.9961 1.93347V9.2434C15.9961 10.0971 15.1772 10.7941 14.1742 10.7941H1.82187C0.818844 10.7941 0 10.0971 0 9.2434V1.93347C0.000177778 1.07794 0.817067 0.385687 1.82187 0.382812ZM15.0516 1.86628L8.90044 6.23439C8.36231 6.6166 7.58418 6.60783 7.06951 6.21563L0.944533 1.86628C0.942222 1.88838 0.940978 1.91077 0.940978 1.93347V9.2434C0.940978 9.65497 1.33849 9.99315 1.82187 9.99315H14.1742C14.6576 9.99315 15.0551 9.65497 15.0551 9.2434V1.93347C15.0551 1.91077 15.0539 1.88838 15.0516 1.86628ZM8.30133 5.62112L14.4828 1.23168L14.1744 1.18371L1.77707 1.18477L1.5136 1.23183L7.69689 5.62127C7.87289 5.74655 8.12587 5.74565 8.30133 5.62112Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1b5103c76942fa7bb5eae86ea3cffa5f.svg";
export { ForwardRef as ReactComponent };